import styled from 'styled-components'
import { Box } from 'reflexbox/styled-components'

import { getHeadingAttrs } from './helpers'

const HEADING_LEVEL = 'h3'

const H3 = styled(Box)
  .attrs(
    getHeadingAttrs(HEADING_LEVEL, {
      // TODO: probably want to hardcocde some better defaults.. these are for H1
      fontSizes: {
        mobile: '36px',
        tablet: '52px',
        desktop: '64px',
      },
    })
  )
  .withConfig({
    shouldForwardProp: (prop) => ['defaultFontSizes'].indexOf(prop) === -1,
  })``

export default H3
